import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSingleselect = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 7.2C4 6.07989 4 5.51984 4.21799 5.09202C4.40973 4.71569 4.71569 4.40973 5.09202 4.21799C5.51984 4 6.0799 4 7.2 4H16.8C17.9201 4 18.4802 4 18.908 4.21799C19.2843 4.40973 19.5903 4.71569 19.782 5.09202C20 5.51984 20 6.0799 20 7.2V16.8C20 17.9201 20 18.4802 19.782 18.908C19.5903 19.2843 19.2843 19.5903 18.908 19.782C18.4802 20 17.9201 20 16.8 20H7.2C6.07989 20 5.51984 20 5.09202 19.782C4.71569 19.5903 4.40973 19.2843 4.21799 18.908C4 18.4802 4 17.9201 4 16.8V7.2Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.0748 9H8.92522C8.46738 9 8.23847 9 8.13246 9.12408C8.04049 9.23174 7.99168 9.39324 8.00117 9.55851C8.0121 9.74897 8.17397 9.97082 8.49771 10.4145L11.5725 14.6286C11.7221 14.8337 11.797 14.9362 11.8832 14.9747C11.9591 15.0084 12.0409 15.0084 12.1168 14.9747C12.203 14.9362 12.2779 14.8337 12.4275 14.6286L15.5023 10.4145C15.826 9.97082 15.9879 9.74897 15.9988 9.55851C16.0083 9.39324 15.9595 9.23174 15.8675 9.12408C15.7615 9 15.5326 9 15.0748 9Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSingleselect;
